import Vue from 'vue'
import LazyImage from '../components/lazyImage.vue'

// 工厂函数：保留原有组件名（avatarLazy / logoLazy / peopleLazy），
// 内部统一指向 LazyImage，仅在默认 type 上有差异。
// 这样既消除了三个近乎重复的 .vue 文件，又对调用方完全透明。
const createLazyComponent = (defaultType) => ({
  props: ['lazyimg'],
  render(h) {
    return h(LazyImage, {
      props: {
        lazyimg: this.lazyimg,
        type: defaultType,
      },
    })
  },
})

Vue.component('avatarLazy', createLazyComponent('avatar'))
Vue.component('logoLazy', createLazyComponent('logo'))
Vue.component('peopleLazy', createLazyComponent('people'))